import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

// Import components
import { CartProvider } from "./context/CartContext"; // Ensure this is the correct path
import Footer from "./components/Footer"; // Ensure this is the correct path
import Carousel from "./components/Carousel"; // Ensure this is the correct path
import Contact from "./components/Contact"; // Ensure this is the correct path
import HomePage from "./context/Home";

function App() {
  return (
    <div className="App">
      <CartProvider>
        {/* Navbar */}
        <nav className="navbar navbar-expand-lg navbar-light bg-primary">
          <div
            className="container-fluid"
            style={{ fontFamily: "'Baloo Bhaijaan 2'" }}
          >
            <a
              to="/"
              className="navbar-brand text-light"
              style={{ fontWeight: "700", fontSize: "26px" }}
            >
              اطلب ماتريد
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="d-flex">
              <button
                className="btn btn-light"
                style={{ fontFamily: "Baloo Bhaijaan 2" }}
              >
                EN
              </button>
            </div>
          </div>
        </nav>

        {/* Carousel Section */}
        <Carousel />

        {/* Page Content */}
        <HomePage />
        <div>{/* Add page-specific content here */}</div>

        {/* Contact Section */}
        <Contact />

        {/* Footer Section */}
        <Footer />
      </CartProvider>
    </div>
  );
}

export default App;
